module.exports = __webpack_public_path__ + "img/logo-dark-mobile.60758344.svg";